import posthog from 'posthog-js';

/**
 * `login_method` e o evento que o design pediu para acompanhar a virada da
 * flag: quanto do login ja entra pelo IDP e quanto ainda entra pela senha.
 *
 * Mora separado do `log.ts` porque aquele nao pode depender de nada — e
 * chamado de dentro do fluxo de autenticacao, inclusive quando ele falha.
 */
export type LoginMethod = 'idp' | 'legacy';

export function captureLoginMethod(method: LoginMethod): void {
  try {
    posthog.capture('login_method', { method });
  } catch {
    // Analytics nunca derruba login. PostHog sem chave configurada (dev, CI)
    // lanca na captura, e isso nao pode virar erro de autenticacao.
  }
}
